<div class="page-title-container" [ngClass]="customClass" #titleContainer>
  <span class="title-text" #titleText>{{ titleKey | translate }}</span>
  <img src="assets/icons/chapeau.png" 
        [alt]="titleKey | translate" 
        class="title-hat" 
        #titleHat />
</div>